module.exports = __webpack_public_path__ + "static/media/chevron-right-primary.f023e746.svg";